<template>
  <div
    v-show="uploads.length"
    class="uploads-progress"
    data-tst="uploads_progress"
  >
    <UploadMenu
      :uploads="uploads"
      @click:retry="retryFailedUploads()"
    >
      <div class="f-center position-relative">
        <div class="mdi pa-2 icon_btn mdi-upload"></div>
        <ProgressCircle
          data-tst="uploads_progress_circle"
          class="position-absolute"
          :valueUnit="totalProgress * 100"
          :strokeWidthPx="2"
          style="--size: 1.75rem; --clr-stroke-back: var(--clr-black-3)"
        />
        <div
          v-if="failed.length && totalProgress === 1"
          class="uploads-fail-circle"
        ></div>
      </div>
    </UploadMenu>
  </div>
</template>

<script>
import { throttle } from 'lodash'
import { v4 as uuid } from 'uuid'
import ProgressCircle from '@/components/lib/ProgressCircle'
import UploadMenu from './UploadMenu'

export default {
  name: 'UploadsProgress',
  components: {
    UploadMenu,
    ProgressCircle,
  },
  data() {
    return {
      total: 0,
      totalProgress: 0,
      uploads: [],
      failed: [],
      retryFiles: [],
      // mock:
      // total: 1,
      // totalProgress: 1,
      // uploads: [{ file: { name: 'test' } }],
      // failed: [{ file: { name: 'test' } }],
    }
  },
  methods: {
    fakeIncrement() {
      // makebelieve for the user when uploading a large file
      if (!this.uploads.length) return
      if (this.totalProgress === 0.8) return

      this.totalProgress += 0.01
      if (this.totalProgress < 1) {
        setTimeout(this.fakeIncrement, 500 * (1 - this.totalProgress))
      }
    },
    retryFailedUploads() {
      const retryFiles = this.retryFiles.map(item => ({
        file: item.file,
        callId: uuid(),
        startTime: Date.now(),
        status: 'waiting',
      }))
      this.totalProgress -= this.failed.length
      this.failed = []
      this.uploads = []
      this.$store.dispatch('api_add_uploads', { files: retryFiles })
      this.$store.dispatch('api_upload_next_file')
    },
    handleUploadUpdate: throttle(function () {
      const total = this.api_uploads.length
      let loaded = 0

      this.api_uploads.forEach(item => {
        if (item.status === 'finished' || item.status === 'error') {
          // total += item.progressEvent?.total
          loaded += 1
        }

        if (item.status === 'error' && !this.failed.includes(item)) {
          this.failed.push(item)
        }
      })
      if (total === 0) {
        // done uploading, resets with next file drop
        this.totalProgress = 1
        this.uploads[this.uploads.length - 1] = {
          filesLength: this.total,
          totalProgress: 1,
          status: 'finished',
          failed: this.failed,
        }
        this.retryFiles = this.failed
        this.uploads.push({ placeholder: true })
        this.uploads = [...this.uploads]
        return
      }
      this.totalProgress = loaded / total

      if (!this.uploads.length) {
        this.uploads.push({ placeholder: true })
      }
      this.uploads[this.uploads.length - 1] = {
        totalProgress: this.totalProgress,
        filesLength: this.total,
        status: 'progress',
        failed: this.failed,
      }
      this.uploads = [...this.uploads]
    }, 500),
  },
  computed: {
    api_uploads() {
      return this.$store.state.api.api_uploads
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
  watch: {
    api_uploads() {
      this.total = this.api_uploads.length || this.total
      this.api_uploads.forEach(item => {
        if (item.status === 'error' && !this.failed.includes(item)) {
          this.failed.push(item)
        }
      })

      this.handleUploadUpdate()

      if (!this.totalProgress) {
        this.fakeIncrement()
      }
    },
    totalProgress() {
      this.uploads = this.uploads.map(i => ({ ...i, totalProgress: this.totalProgress }))
    },
  },
}
</script>
<style lang="scss" scoped>
.uploads-progress {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .upload-circle-progress {
    position: absolute;
    z-index: 1;
  }
}
.uploads-fail-circle {
  position: absolute;
  border-radius: 99px;
  width: 0.75rem;
  height: 0.75rem;
  background: var(--clr-error);
  top: 0.325rem;
  right: 0;
  z-index: 1;
}
</style>
